import React from 'react';
import { Flex, xcss, Stack, Box } from '@atlaskit/primitives';
import AddIcon from '@atlaskit/icon/core/add';
import { token } from '@atlaskit/tokens';
import { ModalEntryPointDropdownItemTrigger } from '@atlassian/jira-modal-entry-point-dropdown-item-trigger/src/ModalEntryPointDropdownItemTrigger.tsx';
import { fireUIAnalytics, useAnalyticsEvents } from '@atlassian/jira-product-analytics-bridge';
import { useIntl } from '@atlassian/jira-intl';

import { browseTemplateModalEntryPoint } from './entrypoint.tsx';
import messages from './messages.tsx';

export const CreateDeveloperAgentDropdownItem = () => {
	const { formatMessage } = useIntl();
	const { createAnalyticsEvent } = useAnalyticsEvents();

	return (
		<ModalEntryPointDropdownItemTrigger
			entryPoint={browseTemplateModalEntryPoint}
			entryPointProps={{}}
			interactionName="create-developer-agent-open-modal-button"
			useInternalModal={false}
			onClick={() => {
				fireUIAnalytics(
					createAnalyticsEvent({}),
					'button clicked',
					'createCodingAgentTemplateDropdownItem',
				);
			}}
			// Moved inside after test is written
			// eslint-disable-next-line jira/integration/test-id-by-folder-structure
			testId="autodev-agent-picker.ui.picker-content.create-coding-agent-button"
		>
			<Flex alignItems="center">
				<Flex xcss={iconWrapperStyles} alignItems="center" justifyContent="center">
					<AddIcon label={formatMessage(messages.createCodingAgentButtonLabel)} />
				</Flex>
				<Stack xcss={titleSubTitleWrapperStyles}>
					<Box as="span" xcss={truncateTextStyles}>
						{formatMessage(messages.createCodingAgentButtonLabel)}
					</Box>
					<Box as="span" xcss={[subLabelStyles, truncateTextStyles]}>
						{formatMessage(messages.createCodingAgentButtonSubLabel)}
					</Box>
				</Stack>
			</Flex>
		</ModalEntryPointDropdownItemTrigger>
	);
};

const iconWrapperStyles = xcss({
	width: '16px',
	marginRight: 'space.250',
});

const titleSubTitleWrapperStyles = xcss({
	minWidth: '0',
	height: '100%',
	textAlign: 'left',
	flex: 1,
	justifyContent: 'center',
	paddingRight: 'space.100',
});

const truncateTextStyles = xcss({
	whiteSpace: 'nowrap',
	overflow: 'hidden',
	textOverflow: 'ellipsis',
});

const subLabelStyles = xcss({
	minWidth: '0',
	color: 'color.text.subtlest',
	font: token('font.body.small'),
});
